import {DateUtil} from "base/format/utilities";
import {TextLink} from "base/navigation/components";
import {ViolationTypeTags} from "violation/presentational";

export function useViolationsTable() {
    const tableColumns = [
        {
            id: "code",
            label: "Código",
            formatFunction: item => (
                <TextLink
                    text={item?.code}
                    to={`/violations/all/list/${item.id}/summary`}
                    textStyle={{fontSize: "inherit"}}
                />
            ),
            width: 10,
        },
        {
            id: "on_date",
            label: "Data",
            formatFunction: item => DateUtil.formatDate(item?.on_date),
            width: 10,
        },
        {
            id: "status",
            label: "Estado",
            width: 15,
        },
        {
            id: "holder",
            label: "Infractor/a",
            formatFunction: item => (
                <TextLink
                    text={item?.holder?.name}
                    to={`/holders/all/list/${item?.holder?.id}/summary`}
                    textStyle={{fontSize: "inherit"}}
                />
            ),
            width: 20,
        },
        {
            id: "district",
            label: "Distrito",
            width: 10,
        },
        {
            id: "plot__land_ownership",
            label: "Propriedade da terra",
            formatFunction: item => {
                return item?.plot?.land_ownership;
            },
            width: 15,
        },
        {
            id: "types",
            label: "Tipo",
            formatFunction: item => {
                return <ViolationTypeTags types={item?.types} />;
            },
            disableSorting: true,
            width: 30,
        },
    ];

    return {tableColumns};
}
